// Fragments: a few lines in the makers' own words, each found at a
// milestone (src/domain/fragments.ts says which). They say nothing a player
// needs to win; they say who counted in threes, and why. Part of the design
// lock (see src/config/history.ts).

import type { GlyphKey } from "../domain/rings.ts"

export const FRAGMENT_IDS = ["first", "still", "sink", "rise", "whole", "order"] as const
export type FragmentId = (typeof FRAGMENT_IDS)[number]

export type FragmentConfig = { readonly seal: GlyphKey; readonly text: string }

export const FRAGMENTS = {
  first: {
    seal: "*",
    text: "This is the smallest rite. One ring, three cards: up, level, down. Fold them and nothing is left over. We gave it to children first.",
  },
  still: {
    seal: "**0",
    text: "The middle tablet is the one we lived on. Every rite on it ends the same way. What was many becomes one, and the one is bright.",
  },
  sink: {
    seal: "**-",
    text: "Below us the water showed everything upside down. We learned to read it. What rises there sinks here. It is the same card.",
  },
  rise: {
    seal: "**+",
    text: "Above us the tide turned the sky over each time something was finished. The oldest thing came to the surface. We did not fear it.",
  },
  whole: {
    seal: "***",
    text: "Twenty-seven rites, one for every card. You have walked the whole cube. This is how we folded our world when we left it.",
  },
  order: { seal: "0*0", text: "Every sign in its place. You can read us now. Few could." },
} as const satisfies Record<FragmentId, FragmentConfig>
